import { universal } from '../../components/loadable';
import { Spinner } from '../../components/Spinner/Spinner';

export const LoadableSSOPage = universal(import('./SSOPage'), {
  key: 'HotSSOPage',
  loading: Spinner,
});
